module.exports = "<checklist-item \n  *ngFor=\"let item of list\"\n  (onSelectItem)=\"onSelectItem($event)\"\n  [item]=\"item\"  \n></checklist-item>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/checklist/checklist.component.html
// module id = 1214
// module chunks = 0